import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20illustration%20featuring%20stylized%20Korean%20manhwa%20webtoon%20panels%20arranged%20in%20an%20abstract%20collage%2C%20soft%20warm%20cream%20and%20coral%20tones%2C%20elegant%20flowing%20composition%20with%20ink%20wash%20texture%2C%20minimalist%20Korean%20aesthetic%20with%20subtle%20gradients%2C%20no%20text%2C%20artistic%20background&width=1600&height=700&seq=hero-bg-2026&orientation=landscape"
        alt="韩漫屋 - 免费在线韩国漫画阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
            探索精彩韩漫世界
          </h1>
          <p className="text-base md:text-lg text-white/85 mb-8 max-w-xl mx-auto leading-relaxed">
            韩漫屋为您精心准备了海量优质韩国漫画，<strong>免费在线漫画</strong>随心阅读，画质优秀、更新迅速，是您探索<strong>精彩韩漫大全</strong>的理想起点。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/romance"
              className="inline-flex items-center px-8 py-3 rounded-md text-sm font-semibold whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-book-open-line mr-2 w-4 h-4 flex items-center justify-center"></i>
              立即开始阅读
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center px-8 py-3 rounded-md text-sm font-semibold whitespace-nowrap bg-white/15 text-white hover:bg-white/25 backdrop-blur-sm transition-all duration-300 cursor-pointer border border-white/25"
            >
              <i className="ri-information-line mr-2 w-4 h-4 flex items-center justify-center"></i>
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white" style={{ fontFamily: "var(--font-heading)" }}>5,000+</p>
              <p className="text-xs text-white/70 mt-1 whitespace-nowrap">漫画资源</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white" style={{ fontFamily: "var(--font-heading)" }}>120万+</p>
              <p className="text-xs text-white/70 mt-1 whitespace-nowrap">注册用户</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white" style={{ fontFamily: "var(--font-heading)" }}>8万+</p>
              <p className="text-xs text-white/70 mt-1 whitespace-nowrap">日活跃用户</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center pt-2">
          <div className="w-1 h-2 bg-white/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}